// Implements: F-UIX-019, F-GEN-036
/**
 * `GET /api/admin/model-settings/catalogue` (mockup v3 P7, contract C7.2): the provider's model
 * list, searched (`q`, accent- and case-insensitive on the server), filtered to the models that
 * reason, and bounded (`limit`, 50 by default). It lists models and calls none: it is free.
 *
 * Platform admin only (`model_settings:manage`). A `503` with `reason: "catalogue_unavailable"`
 * means the provider did not answer in time; the picker says so and the model is typed by hand.
 * It is not retried behind the admin's back (`retry: false`): the server already waited its own
 * deadline, and the next search asks again.
 */

import { httpRequest } from "../../../shared/api/httpClient";
import type { CatalogueQuery, CatalogueView } from "../../../types/modelCatalogue";
import { MODEL_SETTINGS_PATH } from "./modelSettingsApi";

export const CATALOGUE_PATH = `${MODEL_SETTINGS_PATH}/catalogue`;

export function catalogueUrl(query: CatalogueQuery): string {
  const params = new URLSearchParams();
  const q = query.q?.trim() ?? "";
  if (q !== "") params.set("q", q);
  if (query.reasoning_only === true) params.set("reasoning_only", "true");
  if (query.limit !== undefined) params.set("limit", String(query.limit));
  const search = params.toString();
  return search === "" ? CATALOGUE_PATH : `${CATALOGUE_PATH}?${search}`;
}

export async function fetchModelCatalogue(query: CatalogueQuery, signal?: AbortSignal): Promise<CatalogueView> {
  const view = await httpRequest<CatalogueView>(catalogueUrl(query), { signal, retry: false });
  if (view === undefined) throw new Error("The model catalogue answered no body.");
  return view;
}
